import { Decimal } from '@snap-types/types/decimal';

import { calculateContributionMarginFromUnitPrice } from './contribution-margin';
import { calculateGrossMarginFromUnitPrice } from './gross-margin';

type NullToUndefined<T> = T extends null ? undefined : T;

export function calculateMarginsFromUnitPrice<
  T extends Decimal | null | undefined,
  V extends Decimal | null | undefined,
>({
  unitCost,
  unitVariableCosts,
  unitPrice,
}: {
  unitCost?: T;
  unitVariableCosts?: V;
  unitPrice: Decimal;
}): {
  grossMargin: NullToUndefined<T>;
  contributionMargin: NullToUndefined<V>;
} {
  const grossMargin = unitCost
    ? calculateGrossMarginFromUnitPrice({
        unitCost,
        unitPrice,
      })
    : undefined;

  const contributionMargin = unitVariableCosts
    ? calculateContributionMarginFromUnitPrice({
        unitVariableCosts,
        unitPrice,
      })
    : undefined;

  return {
    grossMargin: (grossMargin ?? undefined) as NullToUndefined<T>,
    contributionMargin: (contributionMargin ?? undefined) as NullToUndefined<V>,
  };
}
